import type { Project } from '~/types/project.type'
import type { Task } from '~/types/task.type'
import { useStorage } from '@vueuse/core'

export default function useLastManualTimeEntry() {
  const storage = useStorage<{
    projectId?: Project['id']
    taskId?: Task['id']
    durationSec?: number
  }>('last-manual-time-entry', {})

  return storage
}
